import { TemplateRef } from '@angular/core';

export interface IListItem {
  text?: string;
  template?: TemplateRef<any>;
}
